// extracted by mini-css-extract-plugin
export default {"tasks":"rN-z","task":"sN-z","svg":"tN-z","text":"uN-z"};